import {MealPlan} from '@findhotel/sapi'
import {getNumberOfNights} from 'utils/offers'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {getSplitBookingDates} from '@vio/core/src/room/business/utils/getSplitBookingDates'
import {getSplitBookingRooms} from '@vio/core/src/room/business/utils/getSplitBookingRooms'
import {SplitBooking} from '@vio/core/src/room/types/room'
import {Meal} from '@vio/shared/src/accommodation/OfferPerks/Meal'
import {SplitBookingRoomTags} from '@vio/shared/src/booking/SplitBooking/SplitBookingRoomTags'
import {SplitBookingTimeline} from '@vio/shared/src/booking/SplitBooking/SplitBookingTimeline'
import {BookingTransitionMessage} from '@vio/shared/src/booking/SplitBooking/SplitBookingTransitionMessage'

const SplitBookingRoom = ({
  roomName,
  checkIn,
  checkOut,
  mealPlan
}: {
  roomName: string
  checkIn: string
  checkOut: string
  mealPlan: MealPlan[]
}) => {
  const numberOfNights = getNumberOfNights(checkIn, checkOut)
  return (
    <Box flex="1" display="flex" flexDirection="column" gap="s300">
      <SplitBookingRoomTags
        checkIn={checkIn}
        checkOut={checkOut}
        numberOfNights={numberOfNights}
      />
      <Text variant="titleM">{roomName}</Text>

      {mealPlan && mealPlan.length > 0 && <Meal mealPlan={mealPlan} />}
    </Box>
  )
}

export const DealDetailsSplitBookingOverview = ({
  splitBooking
}: {
  splitBooking: SplitBooking
}) => {
  const splitBookingRooms = getSplitBookingRooms(splitBooking)
  const splitBookingDates = getSplitBookingDates(splitBooking)
  return (
    <Box display="flex" flexDirection="column" gap="s500">
      <Text>
        <FormattedMessageWrapper
          id="dealDetails.splitBookingDisclaimer"
          defaultMessage="This deal splits your stay across two separate bookings."
        />
      </Text>
      <SplitBookingTimeline
        topComponent={
          <SplitBookingRoom
            roomName={splitBookingRooms[0].name}
            checkIn={splitBookingDates.checkIn}
            checkOut={splitBookingDates.splitDate}
            mealPlan={splitBooking.offers[0].offer.mealPlan ?? []}
          />
        }
        bottomComponent={
          <SplitBookingRoom
            roomName={splitBookingRooms[1].name}
            checkIn={splitBookingDates.splitDate}
            checkOut={splitBookingDates.checkOut}
            mealPlan={splitBooking.offers[1].offer.mealPlan ?? []}
          />
        }
        middleComponent={
          <BookingTransitionMessage
            checkIn={splitBookingDates.checkIn}
            checkOut={splitBookingDates.checkOut}
            midDate={splitBookingDates.splitDate}
            title={
              <FormattedMessageWrapper
                id="splitBooking.switchRoomTitleConfirmationPage"
                defaultMessage="Room switch instructions"
              />
            }
            message={
              <FormattedMessageWrapper
                id="splitBooking.roomSwitchTooltipSubtitle"
                defaultMessage="This stay is split between two separate bookings. Here’s how it works:"
              />
            }
          />
        }
      />
    </Box>
  )
}
